module.exports = __webpack_public_path__ + "5a64cb4cf8a8002af8449c3ceb06b961.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/centene_2023_chart.png
// module id = 1649
// module chunks = 0